// extracted by mini-css-extract-plugin
export default {"container":"tx-bogh3nI","uplink":"-8KrIR3ojz","downlink":"_0rT7jJekPq","policy":"isKmxpJ-rN","icon":"yJULPK9-2y"};
    if(module.hot) {
      // 1648553810946
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  